import DOMPurify from 'dompurify'
import { extractYouTubeId } from '../components/global/YouTubeEmbed'

/**
 * Transforme les URLs YouTube en iframes intégrées
 */
const processYouTubeUrls = (html: string): string => {
    if (!html) return ''

    return html.replace(
        /(https?:\/\/(?:www\.)?(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)[\w-]{11})(?:[^\s<]*)/g,
        (url: string): string => {
            const videoId = extractYouTubeId(url)
            if (!videoId) return url

            const isShort = url.includes('shorts/')
            const domain = 'https://www.youtube-nocookie.com'
            const videoUrl = `${domain}/embed/${videoId}?modestbranding=1&rel=0&showinfo=0${
                isShort ? '&playsinline=1' : ''
            }`

            return `
                <div class="youtube-embed" style="width: 100%; max-width: ${
                    isShort ? '315px' : '500px'
                }; margin: 16px 0;">
                    <div style="position: relative; padding-bottom: ${
                        isShort ? '177.78%' : '56.25%'
                    }; height: 0; overflow: hidden; border-radius: 12px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
                        <iframe 
                            src="${videoUrl}" 
                            title="YouTube video player" 
                            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; border-radius: inherit;"
                            allowFullScreen={true}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            loading="lazy"
                        ></iframe>
                    </div>
                </div>
            `
        },
    )
}

/**
 * Nettoie et sécurise le contenu HTML avec DOMPurify
 * Protège contre les attaques XSS
 */
const sanitizeHtml = (html: string): string => {
    if (!html) return ''

    // Balises HTML autorisées pour l'édition de texte riche
    const ALLOWED_TAGS = [
        'p',
        'br',
        'strong',
        'em',
        'u',
        's',
        'blockquote',
        'code',
        'pre',
        'ul',
        'ol',
        'li',
        'a',
        'h1',
        'h2',
        'h3',
        'div',
        'span',
        'iframe',
    ]

    // Attributs autorisés
    const ALLOWED_ATTR = ['href', 'target', 'rel', 'src', 'title', 'style', 'class', 'allowfullscreen', 'allow']

    // Sanitizer le HTML avec DOMPurify
    const sanitized = DOMPurify.sanitize(html, {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
    })

    // Traiter les URLs YouTube après sanitization
    return processYouTubeUrls(sanitized)
}

/**
 * Prépare le contenu HTML pour un rendu sécurisé avec dangerouslySetInnerHTML
 * Transforme automatiquement les URLs YouTube en iframes intégrées
 */
export const renderHtmlContent = (html: string | undefined | null): { __html: string } => {
    if (!html) return { __html: '' }
    return { __html: sanitizeHtml(html) }
}
